'use client';

import dynamic from 'next/dynamic';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import MetaTags from '@/components/meta-tag/meta-tag';
import TechnologyFaq from '@/components/technologies/technology-faq';
import Blog from '@/components/home/blog';
import HireProcessAimlDev from '@/components/technologies/hire-process-aimldev';
import EnterpriseMlModels from '@/components/common/enterprise-ml-models';
import ValuePropositionMachineLearning from '@/components/common/value-proposition-machine-learning';
import WhyMachineLearning from '@/components/common/why-machine-learning';
import OurOfferingMachineLearning from '@/components/common/our-offering-machine-learning';
import TechnicalApproachMachineLearning from '@/components/common/technical-approach-machine-learning';
import IntegrationsTechMachineLearning from '@/components/common/integrations-tech-machine-learning';
import MachineLearningFAQ from '@/components/faqs/machine-learning-faq';
import MachineLearningTechStack from '@/components/home/machine-learning-tech-stack';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHeroMachineLearning = dynamic(() => import('@/components/technologies/tech-hero-machine-learning'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <div className="dark:bg-black">
                <TechHeroMachineLearning />
                <EnterpriseMlModels />
                <ValuePropositionMachineLearning />
                <WhyMachineLearning />
                <OurOfferingMachineLearning />
                <TechnicalApproachMachineLearning />
                <IntegrationsTechMachineLearning />
                <MachineLearningTechStack />
                <HireProcessAimlDev
                    bg="bg-black"
                    pageTitle="Our AI/ML Development Process"
                    desc="Maximize the possibilities of the newest AI/ML version. You can hire our AI/ML developers, who are competent in the technical and interactive abilities required to meet your project's objectives."
                />
                <TechnologyFaq title="FAQs for Machine Learning & MLOps" bg="bg-aiml-faq">
                    <MachineLearningFAQ />
                </TechnologyFaq>
                <CaseStudies />
                <section className="">
                    <ClientTestimonials />
                </section>
                <Blog />
                <div className="section bg-primary py-100 dark:text-light dark:bg-black dark:pt-1">
                    <div className="container lg:container md:mx-auto">
                        <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                            <ContactForm />
                            <ContactInfo />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
